import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { ConnectionService } from '../../service/connection.service';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { SwalService } from '../../service/swal.service';
import { environment } from '../../../environments/environment';
import { TurnstileComponent } from "../../turnstile/turnstile.component";
import { CapsLockWarningDirective } from '../../utility/caps-lock-warning.directive';
import { AuthService } from '../../service/auth.service';
import { GoogleSigninButtonComponent } from '../../google-signin-button/google-signin-button.component';
import { IconComponent } from '../../components/icon/icon.component';

@Component({
  selector: 'app-registrazione',
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslatePipe, TurnstileComponent, CapsLockWarningDirective, GoogleSigninButtonComponent, IconComponent],
  templateUrl: './registrazione.component.html',
  styleUrl: './registrazione.component.css',
})
export class RegistrazioneComponent {
  @ViewChild(TurnstileComponent) turnstile?: TurnstileComponent;
  registration: FormGroup;
  registered = false;
  googleClientId = environment.googleClientId;
  showPassword = false;
  showConfirmPassword = false;

  constructor(
    private connection: ConnectionService,
    private fb: FormBuilder,
    private router: Router,
    private swal: SwalService,
    private translate: TranslateService,
    private authService: AuthService,
  ) {
    this.registration = this.fb.group({
      name: ['', [Validators.required]],
      lastname: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required]],
      confermaPassword: ['', [Validators.required]],
      username: ['', [Validators.required]],
    });
  }

  get email() {
    return this.registration.get('email');
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  toggleConfirmPasswordVisibility() {
    this.showConfirmPassword = !this.showConfirmPassword;
  }

  onSubmit() {
    if (!this.registration.valid) {
      this.swal.error(this.translate.instant('swal.fill_all_required'));
      return;
    }

    if (!this.captchaToken) {
      this.swal.error(this.translate.instant('swal.failed_captcha'));
      return;
    }

    const psw = this.registration.get('password')?.value;
    const cpsw = this.registration.get('confermaPassword')?.value;

    if (psw !== cpsw) {
      this.swal.error(this.translate.instant('swal.password_mismatch'));

      this.registration.get('password')?.setValue('');
      this.registration.get('confermaPassword')?.setValue('');

      return;
    }

    this.connection.post(
      'auth/register',
      {
        name: this.registration.get('name')?.value,
        lastname: this.registration.get('lastname')?.value,
        email: this.registration.get('email')?.value,
        username: this.registration.get('username')?.value,
        password: this.registration.get('password')?.value,
        service: { hair: false, makeup: false, photo: false },
        turnstileToken: this.captchaToken,
      },
      this.registration_success.bind(this),
      this.registration_error.bind(this),
    );
  }

  registration_success(result: any) {
    this.registered = true;
  }

  registration_error(error: any) {
    // Il token Turnstile è usa-e-getta: dopo un tentativo fallito va rigenerato,
    // altrimenti il retry manda un token già consumato e il captcha fallisce.
    this.captchaToken = null;
    this.turnstile?.reset();

    this.swal.errorDialog(
      this.translate.instant('swal.oops'),
      error.error.message || this.translate.instant('swal.registration_error'),
    );
  }

  login() {
    this.router.navigate(['/login']);
  }

  onGoogleSuccess(result: any) {
    // A differenza della registrazione classica, Google ha già verificato
    // l'email: si entra subito, niente schermata "controlla la tua email".
    const route = this.authService.applyLoginResult(result);
    this.router.navigate([route]);
  }

  onGoogleFailure(error: any) {
    this.swal.errorDialog(
      this.translate.instant('swal.oops'),
      error?.error?.message || this.translate.instant('swal.registration_error'),
    );
  }

  //CAPCHA
  turnstileSiteKey = environment.turnstileSiteKey;
  captchaToken: string | null = null;

  onCaptchaToken(token: string): void {
    this.captchaToken = token;
  }
}
